import styled from 'styled-components'
import { white, blue } from '@Constants/ThemeColor'

export const ErrorWrapper = styled.div`
  margin: 0;
  padding: 0;
  body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: ${white};
  }

  .container {
    text-align: center;
    margin: auto;
    padding: 4em;
    img {
      width: 256px;
      height: 225px;
    }

    h1 {
      margin-top: 1rem;
      font-size: 35px;
      text-align: center;

      span {
        font-size: 60px;
      }
    }
    p {
      margin-top: 1rem;
      cursor: pointer;
      color: ${blue};
    }
  }
`
